export default "__VITE_ASSET__r$Nt37GM__"